import styled from 'styled-components';

export const Container = styled.div`
  height: 100vh;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const Title = styled.h1`
  text-align: center;
  font-size: 20px;
  margin-bottom: 150px;

  span {
    font-size: 24px;
    font-weight: 700;
  }

  p {
    margin-top: 16px;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 15px;
`;
